<template>
  <page-edicion>
    <page-header :title="origenOferta.origen" subtitle="Origen de oferta" back-to="/origenOferta" />
    <formulario :origen-oferta="origenOferta" @submit="actualizar" />
  </page-edicion>
</template>

<script>
import Formulario from "./Formulario.vue";
import origenOfertaApi from "@/services/origenOferta.js";

export default {
  components: { Formulario },
  data() {
    return {
      origenOferta: {},
    };
  },
  mounted() {
    this.cargar(this.$route.params.id);
  },
  methods: {
    cargar(id) {
      origenOfertaApi.cargar(id).then((response) => {
        this.origenOferta = response.origenOferta;
      });
    },
    actualizar() {
      origenOfertaApi.actualizar(this.origenOferta).then(() => {
        this.$messages.success("Se ha actualizado el origen de oferta");
        this.$router.push({ path: "/origenOferta" });
      });
    },
  },
};
</script>
